const isValidUrl = {
  url: {
    url: {
      message: "^Provide a valid URL"
    }
  }
};

export { isValidUrl };
